module.exports = __webpack_public_path__ + "img/yard.f6a4c15b.png";